import "kaplay/global";

type ScrumCard = {
  name: string;
  title?: string;
  sprite?: string;
};

const scrumCards = [
  {
    name: "?",
    sprite: "been",
  },
  {
    name: "0",
    title: "0",
  },
  {
    name: "1",
    title: "1",
  },
  {
    name: "2",
    title: "2",
  },
  {
    name: "3",
    title: "3",
  },
  {
    name: "5",
    title: "5",
  },
  {
    name: "8",
    title: "8",
  },
  {
    name: "13",
    title: "13",
  },
  {
    name: "20",
    title: "20",
  },
  {
    name: "40",
    title: "40",
  },
  {
    name: "100",
    title: "100",
  },
  {
    name: "pineapple",
    sprite: "pineapple",
  },
];

const cards = [];

const BOARD_SLOT = 150;

export const createCards = () => {
  const board = add([pos(100, 100), "board"]);

  scrumCards.forEach((scrumCard, i) => {
    const newCard = board.add([
      pos((BOARD_SLOT * i) % (4 * BOARD_SLOT), BOARD_SLOT * Math.floor(i / 4)),
      sprite("card"),
      rotate(),
      animate(),
      anchor("center"),
      area({
        isSensor: true,
      }),
      scale(1),
      "card",
    ]);

    if (scrumCard.title) {
      newCard.add([
        text(scrumCard.title, { font: "happy", size: 32 }),
        anchor("center"),
        "title",
      ]);
    } else {
      newCard.add([sprite(scrumCard.sprite), anchor("center"), "title"]);
    }

    newCard.onCollide("player", (player) => {
      newCard.scaleTo(1.2);
    });

    newCard.onCollideEnd("player", () => {
      newCard.scaleTo(1);
    });

    cards.push(newCard);
  });
};
